module.exports = __webpack_public_path__ + "static/media/logo.e7883d10.png";